function initCharCounters(root = document) {
  root.querySelectorAll('[data-char-counter]').forEach((textarea) => {
    // Prevent double init
    if (textarea.dataset.charCounterInit) return;
    textarea.dataset.charCounterInit = 'true';

    const counterId = textarea.getAttribute('aria-describedby');
    const counter = counterId ? document.getElementById(counterId) : null;
    if (!counter) return;

    const current = counter.querySelector('[data-current]');
    const max = counter.querySelector('[data-max]');
    const maxLength = parseInt(textarea.getAttribute('maxlength'), 10);

    if (max && maxLength) {
      max.textContent = maxLength;
    }

    const updateCounter = () => {
      const length = textarea.value.length;
      current.textContent = length;

      counter.classList.toggle('is-warning', maxLength && length > maxLength * 0.8);
      counter.classList.toggle('is-limit', maxLength && length >= maxLength);
    };

    // Init for prefilled content (important)
    updateCounter();

    textarea.addEventListener('input', updateCounter);
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  initCharCounters();
});

// Theme editor: section loaded
document.addEventListener('shopify:section:load', (event) => {
  initCharCounters(event.target);
});

// Theme editor: section re-rendered (older themes)
document.addEventListener('shopify:section:select', (event) => {
  initCharCounters(event.target);
});


// Checkbox
class InputDisclosureCheckbox extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.label = this.querySelector('label');

    if (!this.checkbox || !this.label) return;

    // Met l’état initial
    this.updateVisualState();

    // Event listener
    this.checkbox.addEventListener('change', () => this.updateVisualState());
  }

  updateVisualState() {
    if (this.checkbox.checked) {
      this.setAttribute('data-checked', 'true');
      this.checkbox.setAttribute('aria-checked', 'true');
    } else {
      this.removeAttribute('data-checked');
      this.checkbox.setAttribute('aria-checked', 'false');
    }
  }
}

// Définition du Custom Element
if (!customElements.get('input-disclosure-checkbox')) {
  customElements.define('input-disclosure-checkbox', InputDisclosureCheckbox);
}
